import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { ComponentValues, Components } from '../../components';
import { StoryblokImage } from '../../storyblok-types';

@Component({
  selector: 'app-storyblok-blur',
  standalone: true,
  imports: [CommonModule, DynamicComponent, DynamicIoDirective],
  templateUrl: './storyblok-blur.component.html',
  styleUrls: ['./storyblok-blur.component.scss'],
})
export class StoryblokBlurComponent {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() body: InstanceType<ComponentValues>[];
  @Input() blur: string;
  @Input() image: StoryblokImage;
  components = Components;

  trackByFunction(index: number, item: InstanceType<ComponentValues>) {
    return item._uid;
  }
}
